export const getOrder = (state, id) => state.orders[id]
export const getOrders = state => state.orders
export const getIsFetching = state => state.orders._isFetching
export const getIsSaving = state => state.orders._isSaving
